"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Caution from foundation/Caution
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Caution = createSVGIcon(
  <>
    <path
      d="M1.632 42.033 25.35 2.692a3.08 3.08 0 0 1 5.3 0l23.718 39.341c1.259 2.094-.233 4.786-2.658 4.786H4.274c-2.425 0-3.917-2.692-2.642-4.786ZM28.008 16.12v17.208"
      stroke="currentColor"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.008 40.9c.979 0 1.772-.804 1.772-1.795s-.793-1.795-1.772-1.795c-.978 0-1.772.804-1.772 1.795s.794 1.795 1.772 1.795"
      fill="currentColor"
    />
  </>,
  "Caution",
  { viewBox: "0 0 56 48", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
